import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import CollectionsSidebar from './CollectionsSidebar';

@inject('popularCollectionsStore')
@observer
class PopularCollections extends Component {
  render() {
    return <CollectionsSidebar
      title={"Popular Collections"}
      positionMenu={false}
      store={this.props.popularCollectionsStore}
    />
  }
}

export default PopularCollections;
